angular.module('pe4h').run(['$templateCache', function($templateCache) {
  $templateCache.put('components/engineers/viewEngineers.html',
    '<update-title title="{{pageTitle}}"></update-title>\n' +
    '<update-meta name="description" content="{{pageDescription}}"></update-meta>\n' +
    '\n' +
    '<section id="viewEngineers" class="content dashboard public">\n' +
    '	<div class="container">\n' +
    '		<div class="row">\n' +
    '			<div class="col-sm-6 col-lg-8">\n' +
    '				<h1>{{engineersTitle || "Engineers"}}</h1>\n' +
    '			</div>\n' +
    '			<div class="col-sm-6 col-lg-4 filters">\n' +
    '				<form>\n' +
    '					<ul class="list-inline form-filters">\n' +
    '						<li class="form-group hidden-xs hidden-sm">\n' +
    '							<h5>Filter</h5>\n' +
    '						</li>\n' +
    '						<li class="form-group filter-a">\n' +
    '							<label class="select input-type">\n' +
    '								<select ng-change="onLicenseChange()" ng-options="l.Label disable when !l.Available for l in engineerLicenses" ng-model="filters.license"\n' +
    '								 class="form-control input-lg">\n' +
    '									<option value="">Licenses (All)</option>\n' +
    '								</select>\n' +
    '							</label>\n' +
    '						</li>\n' +
    '						<li class="form-group filter-b">\n' +
    '							<label class="select input-type">\n' +
    '								<select ng-change="onStateChange()" ng-options="s.Label disable when !s.Available for s in engineerStates" ng-model="filters.state"\n' +
    '								 class="form-control input-lg">\n' +
    '									<option value="">States (All)</option>\n' +
    '								</select>\n' +
    '							</label>\n' +
    '						</li>\n' +
    '					</ul>\n' +
    '				</form>\n' +
    '			</div>\n' +
    '		</div>\n' +
    '		<div class="row license-info">\n' +
    '			<div class="col-md-9">\n' +
    '				<p>{{findLicenseParagraph1(filters.license.Id)}}</p>\n' +
    '				<p>{{findLicenseParagraph2(filters.license.Id)}}</p>\n' +
    '			</div>\n' +
    '			<div class="col-md-3 license-icon">\n' +
    '				<div class="img-container">\n' +
    '					<img ng-if="filters.license.Id" alt="{{filters.license.Label + \'s near me\'}}" style="max-width: 100%; max-height: 100%;" ng-src="{{assetsUrl + \'engineer-icons/\'+filters.license.Id + \'.svg\'}}">\n' +
    '					<img ng-if="!filters.license.Id" alt="Engineers near me" style="max-width: 100%; max-height: 100%;" ng-src="{{assetsUrl + \'engineer-icons/\'+\'0.svg\'}}">\n' +
    '				</div>\n' +
    '				<a href="" ui-sref="post-project" class="btn btn-primary">Get Free Quotes</a>\n' +
    '			</div>\n' +
    '		</div>\n' +
    '		<div id="welcome" ng-cloak class="dashboard-box" ng-show="!loadingEngineers && engineers.length == 0">\n' +
    '			<a class="pull-right close" onclick="document.getElementById(\'welcome\').className=\'hidden\';"></a>\n' +
    '			<h2 class="welcome">No Results{{$state.params.first}}</h2>\n' +
    '			<div class="row">\n' +
    '				<div class="col-sm-8 welcome">\n' +
    '					<p>There are no Engineers meeting your search criteria. Try widening the search.</p>\n' +
    '				</div>\n' +
    '			</div>\n' +
    '		</div>\n' +
    '		<!-- Cards -->\n' +
    '		<div id="cards" custom-scroll on-scroll="onScroll">\n' +
    '			<ul class="dynamic-grid" angular-grid="engineers" ag-grid-width="280" refreshOnImg="false" ag-gutter-size="20" ag-id="gallery"\n' +
    '			 performantScroll="true" scroll-container="#cards" ag-infinite-scroll="getMoreEngineers()" infinite-scroll-distance=\'1\' style="width:100%">\n' +
    '				<li ng-repeat="engineer in engineers" class="grid card">\n' +
    '					<section class="user-profile" style="width: 100%;">\n' +
    '						<ul class="list-inline mb20 clearfix">\n' +
    '							<li class="engineer-photo">\n' +
    '								<div ng-show="engineer.WorkHistoryCount != 0" class="badge" uib-tooltip="Work History" tooltip-popup-close-delay="2000">{{engineer.WorkHistoryCount}}</div>\n' +
    '								<a class="user-photo" style="background-image:url({{engineer.Picture.Url}}),url(assets/img/avatar.png);"></a>\n' +
    '							</li>\n' +
    '							<li class="user-info">\n' +
    '								<!-- Profile Info -->\n' +
    '								<h4>\n' +
    '									<a href="" ui-sref="view-engineer({uid:engineer.Id, engineer_description:generateSEODescriptionForEng(engineer)})">{{engineer.FullName}}</a>\n' +
    '									<small ng-if="engineer.City && engineer.State">{{engineer.City}}, {{engineer.State}}</small>\n' +
    '									<small ng-if="(!engineer.City && engineer.State) || (engineer.City && !engineer.State)">{{engineer.City}} {{engineer.State}}</small>\n' +
    '								</h4>\n' +
    '								<!-- Rating -->\n' +
    '								<div class="rating profile" ng-if="false">\n' +
    '									<span class="review">{{engineer.ReviewCount}}</span>\n' +
    '									<span ng-repeat="i in [5, 4, 3, 2, 1]" ng-class="{\'on\': i <= engineer.AverageScore}"></span>\n' +
    '								</div>\n' +
    '							</li>\n' +
    '						</ul>\n' +
    '						<p>\n' +
    '							<div ng-repeat="license in engineer.groupedLicenses">\n' +
    '								<license-icon license={{license}} licenses={{licenses}}></license-icon>\n' +
    '							</div>\n' +
    '						</p>\n' +
    '						<p class="user-bio" ng-if="engineer.Bio">\n' +
    '							{{engineer.Bio | trimText:true:100:\' ...\'}}\n' +
    '						</p>\n' +
    '						<a ui-sref="view-engineer({uid:engineer.Id, engineer_description:generateSEODescriptionForEng(engineer)})" href="" class="btn btn-primary mt20">View</a>\n' +
    '					</section>\n' +
    '				</li>\n' +
    '			</ul>\n' +
    '			<!-- Load more -->\n' +
    '			<div class="load-cards" ng-show="loading">\n' +
    '				<a href="" class="fa fa-refresh fa-spin"></a>\n' +
    '			</div>\n' +
    '		</div>\n' +
    '</section>');
}]);
